// One loader for the detail page's code: the route renders it, and the list fetches it ahead of the click.
export const loadWorkspaceDetail = () => import('./WorkspaceDetail');
